import {
  formEncode,
  getToken,
  handleResponse,
  nextFormDataApi,
  nextJsonApi,
} from '@/API/core';

const upload = {
  insert: async (formData: any, config?: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.post(
        '/files/upload/insert',
        formEncode(formData),
        {
          ...config,
          timeout: 600000,
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  delete: async (url: string) => {
    let response = null;
    const token = await getToken();

    try {
      response = await nextJsonApi.post(
        '/files/upload/delete',
        { url },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default upload;
